import { render, staticRenderFns } from "./DialogOrderCreate.vue?vue&type=template&id=382754ee&scoped=true"
import script from "./DialogOrderCreate.vue?vue&type=script&lang=js"
export * from "./DialogOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./DialogOrderCreate.vue?vue&type=style&index=0&id=382754ee&prod&lang=css"
import style1 from "./DialogOrderCreate.vue?vue&type=style&index=1&id=382754ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382754ee",
  null
  
)

export default component.exports